import { Box, Divider, Fade, Flex, Hide, Show } from "@chakra-ui/react"
import { Category } from "../../../../api-clients/product-api-v1"
import { pages } from "../../../../common/constants/constants"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import { ChakraNextLinkButton } from "../../../shared/ChakraNextLinkButton"
import { CArrowRight } from "../../../shared/Icons"
import { SectionTitle } from "../../../shared/SectionTitle"
import { CarouselSeries } from "./CarouselSeries"

type Props = {
  seriesCategories: Category[]
}

const Series = ({ seriesCategories }: Props) => {
  const { t } = useBrandedTranslation()

  return (
    <Box as="section">
      <Fade in={!!seriesCategories?.length}>
        <Divider mt={{ base: "10", sm: "16", md: "20" }} mb={{ base: "12", md: "16" }} />
        <Box>
          <Flex justify="space-between" align="center" mb="6">
            <SectionTitle title={t("carousel-series-title")} mb="0" />
            <Show above="xs">
              <ChakraNextLinkButton
                label={t("nav-see-all")}
                color="black"
                leftIcon={<CArrowRight w="5" h="4" />}
                iconSpacing="2.5"
                href={`/${pages.SERIES}`}
              />
            </Show>
          </Flex>
          <CarouselSeries seriesCategories={seriesCategories} />
          <Hide above="xs">
            <ChakraNextLinkButton
              label={t("nav-see-all")}
              color="black"
              border="1px solid"
              variant="secondary"
              width="100%"
              mt="2"
              href={`/${pages.SERIES}`}
            />
          </Hide>
        </Box>
      </Fade>
    </Box>
  )
}

export default Series
